import { useResponsive } from '@sweetgreen/garnish';

export const useLargeDesktopBreakpoint = () => {
  const { screenDimensions, minWidth } = useResponsive();

  return screenDimensions.width >= 1200 && !minWidth.isLG;
};
